import ReactDOM from 'react-dom/client';

import App from './App';
import 'react-tooltip/dist/react-tooltip.css';

import './index.css';

ReactDOM.createRoot(document.getElementById('root') as Element).render(<App />);
